import { render, staticRenderFns } from "./LoginAuth0.vue?vue&type=template&id=30f228c0"
import script from "./LoginAuth0.vue?vue&type=script&lang=js"
export * from "./LoginAuth0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports